import { W, H, R } from "./props";

const cap = (list) => (tt) => (list.find(([a, b]) => tt >= a && tt <= b) || [])[2] || null;
const G = 146;
const snow = (ctx, now, n = 90) => { for (let i = 0; i < n; i++) R(ctx, "#e8f1ff", (i * 73.13 + now * 0.01) % W, (i * 41.7 + now * 0.02) % H, 1, 1); };
const bars = (ctx, tt, dur) => {
  R(ctx, "#000", 0, 0, W, 16); R(ctx, "#000", 0, H - 16, W, 16);
  const fade = tt < 0.8 ? 1 - tt / 0.8 : tt > dur - 1 ? tt - (dur - 1) : 0;
  if (fade > 0) { ctx.fillStyle = `rgba(0,0,0,${Math.min(1, fade)})`; ctx.fillRect(0, 0, W, H); }
};
const COATS = ["#3b3f4a", "#5a4430", "#2f4a6b", "#4a3a5a", "#3d5a3d", "#6b3a2a"];
function person(ctx, x, i, t, a = 1) {
  ctx.globalAlpha = a;
  const st = Math.floor(t / 260 + i) % 2;
  R(ctx, "#1f2430", x + 1 + st, G - 6, 2, 6); R(ctx, "#1f2430", x + 4 - st, G - 6, 2, 6);
  R(ctx, COATS[i % COATS.length], x, G - 15, 7, 9); R(ctx, "#d9b48f", x + 1, G - 20, 5, 5); R(ctx, i % 3 ? "#2a1a10" : "#9a8a70", x + 1, G - 21, 5, 2);
  ctx.globalAlpha = 1;
}
function pale(ctx, x, t, i) {
  const sw = Math.round(Math.sin(t / 500 + i));
  R(ctx, "#e5e7eb", x, G - 22, 8, 22); R(ctx, "#f1e4d8", x + 2, G - 29, 5, 7); R(ctx, "#0b0b0f", x + 1 + sw, G - 31, 7, 3); R(ctx, "#0b0b0f", x + sw, G - 28, 2, 14);
  R(ctx, "#7f1d1d", x + 3, G - 26, 1, 1); R(ctx, "#7f1d1d", x + 5, G - 26, 1, 1);
}

export const TOWN_DURATION = 18;
const TOWN_CAPS = [
  [0.6, 4.2, "Meanwhile. The town at the foot of the mountain."],
  [4.6, 8.4, "Two women walk down the middle of Main Street. Barefoot in the snow."],
  [8.8, 12.6, "One by one, the doors open."],
  [13.0, 17.2, "Nobody screams. Nobody runs. They just... follow."],
];
export const townCaption = cap(TOWN_CAPS);
const HOUSES = [[10, "#3a2a1c"], [70, "#2a2f3a"], [128, "#3a2420"], [186, "#2a3328"], [244, "#3a2a1c"], [290, "#2a2f3a"]];

export function drawTown(ctx, tt, now) {
  ["#05070e", "#080c18", "#0b1222", "#0f182c"].forEach((c, i) => R(ctx, c, 0, i * 30, W, 30));
  for (let s = 0; s < 110; s++) R(ctx, "#0c1426", s * 3, 30 + Math.abs(((s * 2.2) % 80) - 40) * 0.9, 3, H);
  HOUSES.forEach(([x, c], i) => {
    R(ctx, c, x, G - 44, 46, 44); for (let k = 0; k < 6; k++) R(ctx, c, x - 3 + k * 3, G - 50 - k * 3, 52 - k * 6, 3); R(ctx, "#d9e4ee", x - 4, G - 52, 54, 2);
    const lit = Math.sin(now / 300 + i * 2) > -0.6;
    R(ctx, lit ? "#f59e0b" : "#3a2a10", x + 6, G - 34, 9, 8); R(ctx, lit ? "#f59e0b" : "#3a2a10", x + 31, G - 34, 9, 8);
    const open = tt > 8.8 + i * 0.6; R(ctx, open ? "#fcd34d" : "#1a120c", x + 18, G - 18, 10, 18);
  });
  R(ctx, "#4b5563", 120, G - 70, 2, 70); R(ctx, "rgba(253,224,71,0.8)", 117, G - 72, 8, 3);
  R(ctx, "#b6c6d6", 0, G, W, H - G); R(ctx, "#8ea4bb", 0, G, W, 1); R(ctx, "#9fb0c2", 0, G + 12, W, 6);
  const lead = -20 + tt * 15;
  pale(ctx, lead, now, 0); pale(ctx, lead - 12, now, 1);
  HOUSES.forEach(([x], i) => {
    const t0 = 9.2 + i * 0.6; if (tt < t0) return;
    for (let k = 0; k < 2; k++) {
      const out = Math.min(1, (tt - t0 - k * 0.5) / 1.2); if (out <= 0) continue;
      const join = Math.max(0, tt - t0 - k * 0.5 - 1.2), px = x + 21 + k * 4 + Math.min(join * 12, 0) , qx = Math.min(px + join * 14, lead - 26 - (i * 2 + k) * 9);
      person(ctx, join > 0 ? qx : px, i * 2 + k, now, out);
    }
  });
  snow(ctx, now); bars(ctx, tt, TOWN_DURATION);
}

export const MINE_DURATION = 18;
const MINE_CAPS = [
  [0.6, 4.2, "The old mine, an hour before dawn."],
  [4.6, 8.6, "Romulus and Remus lead them in. Dozens of them. Maybe hundreds."],
  [9.0, 13.0, "Below the mountain, every tunnel leads to the same place."],
  [13.4, 17.2, "To the stairs. To the chamber. To the dagger."],
];
export const mineCaption = cap(MINE_CAPS);

export function drawMine(ctx, tt, now) {
  ["#04060c", "#070b15", "#0a101e", "#0d1526"].forEach((c, i) => R(ctx, c, 0, i * 30, W, 30));
  R(ctx, "#141418", 150, 30, W - 150, G - 30); for (let i = 0; i < 12; i++) R(ctx, "#141418", 140 - i * 8, 40 + i * 9, 12 + i * 8, 9);
  R(ctx, "#020203", 236, G - 54, 46, 54); R(ctx, "#4a3420", 230, G - 60, 58, 6); R(ctx, "#4a3420", 230, G - 60, 6, 60); R(ctx, "#4a3420", 282, G - 60, 6, 60);
  R(ctx, "#7a6a4a", 240, G - 70, 38, 8); R(ctx, "#1a120c", 244, G - 68, 30, 4);
  R(ctx, "#5a5a60", 0, G - 2, 240, 2); for (let x = 0; x < 240; x += 10) R(ctx, "#3a2a1c", x, G - 1, 4, 2);
  R(ctx, "#b6c6d6", 0, G, W, H - G);
  const p = Math.min(1, tt / 9);
  [[0, 0], [1, 0.08]].forEach(([k, lag]) => {
    const q = Math.min(1, Math.max(0, p - lag)), x = 60 + q * 196 - k * 34, a = q > 0.9 ? (1 - q) / 0.1 : 1;
    if (a <= 0) return; ctx.globalAlpha = a; pale(ctx, x + 40, now, k); ctx.globalAlpha = 1;
  });
  for (let i = 0; i < 30; i++) {
    const x = -10 + (tt - 2.5) * 22 - i * 11; if (x < -10) continue;
    if (x > 250) continue;
    person(ctx, x, i, now, x > 236 ? Math.max(0, (250 - x) / 14) : 1);
  }
  snow(ctx, now, 70); bars(ctx, tt, MINE_DURATION);
}
